
/* eslint-disable no-useless-escape */
<template>
    <div class="page-editor">
      <CRow>
    <CCol col="10" xl="10">
      <CCard class="pr-0">

        <CCardBody>


                        <a-card class="edit-card" style="margin:0;" :loading="loading">
                          <span slot="title">
                            <h6 class="w-100 mb-0 text-muted">Používateľ</h6><h2 class="">{{fieldData.first_name}} {{fieldData.last_name}}</h2></span>
                          <span slot="extra">

            </span>

<div class="pt-4">
     <div class="col-lg-12" :key="index" v-for="(field, index) in fields">

                            <template v-if="field.type === '17'">
                              <a-form-item :label="field.title"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                              <span class="field-collection mb-3">
                              <draggable  @change="updateMultiOrder" v-bind="dragOptions" :key="componentKey" v-model="fieldData[field.slug]" :group="'fieldcollection' + index" @start="drag=true" @end="drag=false" handle=".handle2">
                                    <span :style="'display:inline-block; width:100%;' + (fieldData[field.slug].length > 1 ? 'border-bottom:0px solid #fff;':'')" :key="componentKey + '_' + indexx" v-for="(fiel,indexx) in fieldData[field.slug]">
                                        <div class="row" style="position:relative" v-if="field.fields">
                                        <a class="handle2" v-if="fieldData[field.slug].length > 1"><i class="fa fa-expand-arrows-alt"></i></a>
                                        <template v-for="(fieldinput,inde) in field.fields[0]">
                                        <field :styles="styles" :input="fieldinput" :key="componentKey + '_' + inde + '_' + indexx" :i="indexx" v-model="fiel[inde]" :options="fieldinput.options" :cl="field.fields[0].length" /></template>
                                        <a-icon class="del-but float-right" title="Odobrať položku" type="minus-circle-o" v-if="fieldData[field.slug].length > 0" @click="() => removefc(indexx,field.slug)"/></div>
                                    </span>
                              </draggable>
                                  <div v-if="field.multi === '1'" style="margin-left:20px; margin-top:18px">
                                  <a-button type="dashed" class="  float-right" @click="addColfields(field.fid)"><a-icon type="plus" style="display:block;margin-top:2px;float:left;" /> Pridať</a-button>
                                  </div>
                                  </span>
                                  </a-form-item>
                            </template>
                                           <div class="form-item-holder mb-3" v-if="field.type === '1'">
                                               <a-form-item :label="field.title"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                                               <a-input alternative=""
                                                        :key="componentKey"
                                                        input-classes="form-control-alternative"
                                                        v-model="fieldData[field.slug]"
                                            />
                                            <a-button  @click="setUrl"  v-if="field.slug === 'url' && fieldData['title']">Vygeneruj automatické url z názvu</a-button>
                                            <i class="fal fa-globe-europe auto-url" title="Preložiť" v-if="field.translatable === '1'"></i>
                                               <div class="sub-translations" v-if="field.translatable === '1'">
<div class="translation" style="position:relative;"  :key="componentKey + translate.short" v-for="translate in languages">
                                                <div  v-if="fieldData.language !== translate.short">
                                                    <a-input alternative=""
                                                               input-classes="form-control-alternative"
                                                               v-model="fieldData[field.slug + ':' + translate.short]"/>
    <i style="position:absolute;top:10px;right:15px" title="Preložiť">{{translate.title}}</i></div>
                                               </div>
                                               </div>

                                               </a-form-item>
                                           </div>


<div  v-if="field.type === '6'">
                                           <a-form-item :label="field.title" :labelCol="labelCol"  :wrapperCol="wrapperCol">
                                               <a-input  class="mb-3" alternative=""
                                                        input-classes="form-control-alternative"
                                                        type="number"
                                                        v-model="fieldData[field.slug]"/>
                                                      </a-form-item>
                                                      </div>
                                            <div  class="mb-3" v-if="field.type === '5'" >
                                              <a-form-item :label="field.title"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                                            <a-input alternative=""
                                                        input-classes="form-control-alternative"
                                                        type="number"
                                                        v-model="fieldData[field.slug]" />
                                                        </a-form-item>
 </div>
                                            <div class="form-item-holder mb-3" v-if="field.type === '4'" >
                                              <a-form-item :label="field.title"  :labelCol="labelCol" :wrapperCol="wrapperCol">

                                                <ckeditor :editor="editor" v-model="fieldData[field.slug]"  :config="editorConfig"></ckeditor>
                                                <i class="fal fa-globe-europe auto-url" title="Preložiť" v-if="field.translatable === '1'"></i>
                                                <div class="sub-translations" style="margin-top:10px;" v-if="field.translatable === '1'">
                                                    <div class="translation" style="position:relative;"  :key="componentKey + translate.short" v-for="translate in languages">
                                                        <div  v-if="fieldData.language !== translate.short">
                                                            <ckeditor :editor="editor" v-model="fieldData[field.slug + ':' + translate.short]"  :config="editorConfig"></ckeditor>
                                                            <i style="position:absolute;top:10px;right:15px">{{translate.title}}</i></div>
                                                    </div>
                                                </div>
                                                <template v-else><div v-if="fieldData.language !== defaultLanguage && field.slug !='url'">
                                                  <a-button title="Preložiť pomocou AI" @click="translateAI(fieldData.language, fieldData[field.slug], field.slug,false)">prelož pomocou AI</a-button>
                                               </div>
                                               </template>
                                              </a-form-item>
                                            </div>
                                            <div class=" mb-3" v-if="field.type === '2'">
                                              <a-form-item :label="field.title"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                                                <a-select class="w-100"  :filter-option="(e,f) => compareData(e,f,field.id)" v-if="field.multi === '0'" defaultValue="1"  v-model="fieldData[field.slug]" :options="options[field.id]"/>
                                                <a-select v-else  class="w-100" mode="multiple" defaultValue="1" v-model="fieldData[field.slug]"   :filter-option="(e,f) => compareData(e,f,field.id)" :options="options[field.id]"/>
                                            </a-form-item>
                                                </div>
                                                <template v-if="field.type === '7'">
                                                  <a-form-item :label="field.title"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                                                    <a-checkbox class="mb-3" v-model="fieldData[field.slug]" />
                                                  </a-form-item>
                                                </template>


                                            <div class="mb-3" v-if="field.type === '3'" :key="reloadgalleries">
                                              <a-form-item :label="field.title"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                                                <image-upload :data="fieldData[field.slug]" :label="field.title" :dat="field.slug"  @changed="(e) => onChildChange(e,field.slug)"></image-upload>
                                                </a-form-item>

                                            </div>
                                            <div class="mb-3" v-if="field.type === '19' && field.multi !== '1'">
                                              <a-form-item :label="field.title"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                                                 <upload :data="fieldData[field.slug]" :label="field.title" :dat="field.slug"  @changed="(e) => onChildChange(e,field.slug)"></upload>
                                              </a-form-item>
                                            </div>




                                            <div class="mb-3" v-if="field.type === '11'" :key="reloadgalleries">

                                              <a-form-item :label="field.title"  :labelCol="labelCol" :wrapperCol="wrapperCol">

                                                <a-upload-dragger
                                                        name="upload"
                                                        :multiple="true"
                                                        :customRequest="(e) => testo(e,field.slug)"
                                                        :headers="head"
                                                        :showUploadList="false"
                                                >
                                                    <p class="ant-upload-drag-icon" style="padding-top:20px;color:#c3e8fc">
                                                      <i class="far fa-file-image" style="font-size:46px;"></i>
                                                    </p>
                                                    <p class="ant-upload-text">
                                                     Klikni, alebo premiestni súbory do tohoto poľa
                                                    </p>

                                                </a-upload-dragger>
                                                <a-button @click="openImageModal(field.slug)" >Nahrať obrázky</a-button>
<div class="setup-panel" v-if="fieldData[field.slug] && JSON.parse(fieldData[field.slug])[Object.keys(JSON.parse(fieldData[field.slug]))[0]]">

<div class="gallery-images" :key="fieldData[field.slug]" v-if="fieldData[field.slug]">
    <draggable tag="div" @change="(e) => log(e,field.slug)" :list="JSON.parse(fieldData[field.slug])" v-bind="dragOptions" @start="drag=true" @end="drag=false"  class="list-group" handle=".handler">
    <div v-for="(imageItem,index) in JSON.parse(fieldData[field.slug])" class="gallery-image-holder" :key="'img'+field.slug+'_'+index">
        <span class="handler"><div class="title" v-if="imageItem.image.title">{{imageItem.image.title}}</div>
<div class="alttag" v-if="imageItem.image.alt">{{imageItem.image.alt}}</div>
<img class="big" :src="IMG_URL + '300:300:1' + imageItem.image.relative">
<div class="image-setup"><a-icon type="edit" @click="setupImage(imageItem.image,index,field.slug)"/><a-icon type="delete" @click="deleteThis(index,field.slug)"/></div></span>
    </div></draggable>
</div></div>
</a-form-item>
                                            </div>




                                            <div   v-if="(field.type === '13' && field.multi === '1')">
                                              <a-form-item :label="field.title"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                                                <multi v-if="fieldData[field.slug]" :data="{'item.multiplier' :JSON.parse(fieldData[field.slug]) }"  multiplier="true" :options="options[field.id]" :items="['item.multiplier']" :editid="index" @changed="(e) => onChildChangeMulti(e,field.slug)"/>
                                                <multi v-else  :items="['item.multiplier']" :options="options[field.id]" :editid="index"  multiplier="false" @changed="(e) => onChildChangeMulti(e,field.slug)"/>
                                              </a-form-item>
                                            </div>
                                            <div   v-if="field.type === '16'">
                                              <a-form-item :label="field.title"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                                                <div v-if="fieldData[field.slug]">
                                                    <div v-for="(fd, index) in fieldData[field.slug]" :key="field.id + index" class="date-row">
                                                        <div v-if="fd" style="margin-left:20px;">
                                                            {{formatDateP(fd[0])}} - {{formatDateP(fd[1])}}
                                                        </div>
                                                        <a-icon class="dynamic-delete-button date-delete" type="minus-circle-o" @click="() => remove(index,field.slug)"/>
                                                    </div>
                                                </div>
                                                <div  class="ant-row-flex"><a-range-picker class="mb-10" :locale="locale" v-model="temp[field.slug]" />

                                                    <a-button type="dashed" class="mb-3" v-if="temp[field.slug]" @click="onChange(temp[field.slug],field.slug)">
                                                        <a-icon type="plus" /> Pridať
                                                    </a-button>
                                                </div>
                                                </a-form-item>
                                            </div>
                                            <div class="mb-3" v-if="field.type === '14'">
                                              <a-form-item :label="field.title"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                                                <a-date-picker v-model="fieldData[field.slug]" v-if="fieldData[field.slug]"  style="width: 100%" :defaultValue="formatDateX(fieldData[field.slug])" :locale="locale" />
                                                <a-date-picker v-model="fieldData[field.slug]"  v-else style="width: 100%" :locale="locale" />
                                                </a-form-item>
                                            </div>
                                            <div class="mb-3" v-if="field.type === '15'">
                                              <a-form-item :label="field.title"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                                                <multi v-if="fieldData[field.slug]" :data="JSON.parse(fieldData[field.slug])" :slug="field.slug" multiplier="false" :items="['title','text']" :editid="index" @changed="(e) => onChildChangeMultiP(e,field.slug)"/>
                                                <multi v-else  :items="['title','text']"  :editid="index" :slug="field.slug"  multiplier="false" @changed="(e) => onChildChangeMultiP(e[field.slug],field.slug)"/>
                                                  </a-form-item>
                                            </div>
                                            <div class="mb-3" v-if="( field.type === '12' && field.multi === '0')">
                                              <a-form-item :label="field.title"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                                              <!---     <autoComplete slug="taxonomysearch" :data="options[field.id]" :contractor="contexts[field.id]"  :title="field.title" class="autoitem" @changed="(e) => onChildTaxChange(e,field.slug)"></autoComplete> -->
                                                <a-select show-search :filter-option="(e,f) => compareData(e,f,field.id)" defaultValue="1"  style="width: 100%"  v-model="fieldData[field.slug]">
                                                    <a-select-option :value="0">Bez priradenia</a-select-option>
                                                    <a-select-option v-for="op in options[field.id]" :key="op.value">{{op.label}}</a-select-option>
                                                </a-select>
                                                <div class="mb-2">
                                                  <a-button @click="addTerm(field)" class="mr-1">+ pridať termín</a-button>
                                                  <span v-if="fieldData[field.slug]"><router-link :to="'/edit-taxonomy-item/' + fieldData[field.slug] + '/' + contexts[field.id]"><a-button class="mr-1">upraviť termín</a-button></router-link></span>
                                                  <span v-if="fieldData[field.slug]"><router-link :to="'/taxonomy-items/' + contexts[field.id]"><a-button>zobraziť slovník</a-button></router-link></span>
                                                </div>
                                                </a-form-item>
                                            </div>
                                            <div  class="mb-3" v-if="field.type === '8' && field.multi !== '1'">
                                              <a-form-item :label="field.title" :labelCol="labelCol" :wrapperCol="wrapperCol">
                                                <template v-if="fieldData[field.slug]">
                                                  <template v-if="fieldData[field.slug] && fieldData[field.slug + '_datax']">
                                                    <div v-if="fieldData[field.slug + '_datax'][fieldData[field.slug]]">
                                                      {{ Object.values(fieldData[field.slug + '_datax'][fieldData[field.slug]]).join(' ') }}
                                                    </div>
                                                  </template>
                                                    <div v-else>{{  fieldData[field.slug + '_data'] }}</div>
                                                  </template>
                                                <span v-if="fieldData[field.slug]" style="float:right">
                                                  <router-link :to="'/edit-content/' + fieldData[field.slug]"><i class="fas fa-external-link-alt"></i></router-link>
                                                </span>
                                                <a-button @click="assignType(context[field.id],field)">
                                                  <template v-if="fieldData[field.slug]">zmeniť položku</template>
                                                  <template v-else>+ pridať položku</template></a-button>
                                              </a-form-item>
                                            </div>
                                            <div class="mb-3" v-if="field.type === '9'">
                                                <div v-if="field.slug === 'city'">
                                                    <label class="form-control-label">{{field.title}}:</label>
                                                    <div v-if="Array.isArray(fieldData[field.slug])">{{fieldData[field.slug][1]}}</div>

                                                    <a-auto-complete
                                                            v-model="fieldData[field.slug]" :dataSource="options[field.id]" @select="(e) => onSelect(e,field.slug)" @search="(e) => onSearch(e,field.id)">   <template slot="dataSource">
                                                        <a-select-option v-for="item in dataSource" :key="item.value" :title="item.text"></a-select-option>
                                                    </template>
                                                    </a-auto-complete>
                                                </div>
                                            </div>
                                            <div class="mb-3" v-if="field.type === '8' && field.multi === '1'">

                                              <a-form-item :label="field.title"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                                              <a-button style="position: absolute; right: 17px; top: 0;" size="small" @click="addContent(field.id)">+ pridať</a-button>
                                                <a-select v-if="fieldData[field.slug]"
                                                   :filter-option="(e,f) => compareData(e,f,field.id)"
                                                   mode="multiple" style="width: 100%"  v-model="fieldData[field.slug]" placeholder="Please select">
                                                    <a-select-option v-for="op in options[field.id]" :key="op.value">{{op.label}}</a-select-option>
                                                </a-select>

                                               <a-select v-else
                                                          mode="multiple"
                                                          :filter-option="(e,f) => compareData(e,f,field.id)"
                                                          style="width: 100%"
                                                          @change="(e) => onChildChange(e,field.slug)"
                                                          placeholder="Please select"
                                                >
                                                    <a-select-option v-for="op in options[field.id]" :key="op.value">{{op.label}}</a-select-option
                                                    >
                                                </a-select>

</a-form-item>
                                            </div>

                                            <div class="mb-3" v-if=" field.type === '12' && field.multi === '1'">
                                              <a-form-item :label="field.title"  :labelCol="labelCol" :wrapperCol="wrapperCol">
                                                <a-select v-if="fieldData[field.slug]"
                                                          mode="multiple" style="width: 100%" :defaultValue = "JSON.parse(fieldData[field.slug])"
                                                          @change="(e) => onChildChange(e,field.slug)" placeholder="Please select">
                                                    <a-select-option v-for="op in options[field.id]" :key="op.value">{{op.label}}</a-select-option>
                                                </a-select>

                                                <a-select v-else
                                                          mode="multiple"
                                                          style="width: 100%"
                                                          @change="(e) => onChildChange(e,field.slug)"
                                                          placeholder="Please select"
                                                >
                                                    <a-select-option v-for="op in options[field.id]" :key="op.value">{{op.label}}</a-select-option
                                                    >
                                                </a-select>
                                              </a-form-item>
                                            </div></div>
</div>


                    </a-card>
        </CCardBody>
      </CCard>
      </CCol>

<CCol col="2" xl="2" class=" option-card">
<CCard class="pl-0">
  <CCardBody>
    <a-card class="edit-card" style="margin:0; padding:15px;" :loading="saving">
                                <div class="option-buttons">
                              <router-link to="/users"><a-button>Späť na zoznam</a-button></router-link>
                                  <a-button type="secondary"  class="fs-12"   @click="resendPass">Preposlať heslo</a-button>
                                   <a-button type="primary"  class="fs-12"  @click="handleSubmit">Uložiť</a-button>
                            </div>

      </a-card>

  </CCardBody>
</CCard>
  </CCol>
      </CRow>
                </div>
</template>
<script>
    import {API_URL} from "../api";
    import {authHeader} from "../_helpers";
    import {dataService} from "../_services";
    import Vue from "vue"
    import {Modal} from 'ant-design-vue'

    import moment from 'moment'
    import 'moment/locale/sk';
    import FormItem from 'ant-design-vue'
    import {Cropper} from 'vue-advanced-cropper'

    Vue.use(FormItem, Modal);
    Vue.use(Cropper);

    function getBase64(img, callback) {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    }

    function dataURLtoFile(dataurl, filename) {

        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, {type: mime});
    }


    export default {
        name: 'user',
        props: ['id'],

        data() {
            return {
                loading: true,
                visible: false,
                originInfo: '',
                imageUrl: '',
                fileList: [],
                roleOptions: [],
                colorsto: JSON.parse(localStorage.colors),
                imgCroppFile: '',
                uploading: false,
                 taxonomies: {},
                productSearch:false,
                defaultLanguage:'sk',
                prev:false,
                modified:false,
                lat:0,
                lng:0,
                revisionsShow:false,
                imageToSet:{},
                hasBuilder:false,
                hasMultiDocuments:false,
                hasProductOptions:false,
                saving:false,
                refreshassignlist:0,
                context:[],
                crawlUrl:"",
                showoptions:[],
                contexts: {},
                ImagesetupVisible:false,
                styles:[],
                temp:{},
                componentKey:0,
                forceRefresh:0,
                translatedata:[],
                labelCol: { span: 4 },
                wrapperCol: { span: 20 },
                reloadimages:{},
                productOptionsCategories: [],
                productOptions: [],
                pdfResolvedUrl: '',
                showImages:false,
                crawledImages:[],
                reloadgalleries:0,
                history:[],
                croppedImage: '',
                imageUploaded: '',
                roles: '',
                head: authHeader(),
                send: API_URL,
                formItemLayout: {
                    labelCol: {span: 6},
                    wrapperCol: {span: 14},
                },
                userId: {
                    uid: this.id
                },
                options:[],
                fieldData: {
                    first_name: '',
                    last_name: '',
                    image: this.imageUploaded,
                },
                  fields: [
        { slug: 'first_name', type: '1', title: 'Meno', multi: '0', translatable: '0' },
        { slug: 'last_name', type: '1', title: 'Priezvisko', multi: '0', translatable: '0' },
        { slug: 'username', type: '1', title: 'Používateľské meno', multi: '0', translatable: '0' },
        { slug: 'email', type: '1', title: 'Email', multi: '0', translatable: '0' },
        { slug: 'password', type: '1', title: 'Heslo', multi: '0', translatable: '0', inputType: 'password' },
        { slug: 'password_repeat', type: '1', title: 'Zopakujte heslo', multi: '0', translatable: '0', inputType: 'password' },
        { slug: 'type_id', type: '2', title: 'Typ konta', multi: '1', translatable: '0', id: 123 },
      ],
                model: {
                    username: '',
                    email: '',
                    firstName: '',
                    lastName: '',
                    address: '',
                    city: '',
                    country: '',
                    zipCode: '',
                    about: '',
                }
            }
        },
        methods: {
            showModal() {
                this.visible = true;
            },
            resendPass()
            {
                dataService.axiosFetch('resendpassword', this.id).then(results => {
                    this.fieldData = results;
                });
            },
            handleOk() {
                this.visible = false;
                var headers = authHeader(true);
                let formData = new FormData();
                formData.append('upload', dataURLtoFile(this.imgCroppFile, this.originInfo.name));
                const pa = this;
                this.axios.post(API_URL + '/upload/user',
                    formData,
                    {
                        headers: headers
                    }
                ).then(function (data) {
                    pa.fieldData.imageUploaded = data.data[0];
                    console.log(pa);
                });

                return true;
            },
              onChildChangeBuilder(value,slug) {
                this.fieldData[slug] = JSON.stringify(value);
            },
             onChildChangeFc(input,od,ind)
            {
                this.fieldData[this.contenttype.fields[od].slug][od][ind] = input;

            },
             bool(v) {
                return v === 'true' || v === '1';
            },
            deleteThis(index,slug)
            {
                let parsed = JSON.parse(this.fieldData[slug]);
                parsed.splice(index, 1);
                this.fieldData[slug] = JSON.stringify(parsed);


            },
            onChange(e,slug)
            {

                if(!this.fieldData[slug])
                    this.fieldData[slug] = [];
                e[0] = e[0].unix();
                e[1] = e[1].unix();
                this.fieldData[slug].push(e);
                this.temp = {};
            },
            remove(index,slug)
            {
                this.fieldData[slug].splice(index, 1);
            },
            onChildChangeMulti(value,slug)
            {
                for(var i in value){
                    this.fieldData[slug] = JSON.stringify(Object.values(value[i]));
                }

            },
            setupImage(image,index,slug)
            {

                this.imageToSet = image;
                this.imageToSet.index = index;
                this.imageToSet.slug = slug;
                this.ImagesetupVisible = true;
            },
            handleGlobalEdit(e,slug)
            {
                 let parsed = JSON.parse(this.fieldData[slug]);
                 parsed.forEach(obj => {
                          obj.image.style = e;
                });

                this.fieldData[slug] = JSON.stringify(parsed);
            },
   onSelect(value,slug) {
                this.fieldData[slug] = value;
            },
            priceCompare()
            {

            dataService.axiosFetch("pricecompare/"+this.id).then(results => {
                    console.log(results);
                });

            },
            onSearch(e,f)
            {
                dataService.axiosFetch("dynamic/"+f, e).then(results => {
                    this.options[f] = results;
                });


            },
            jsonU(a)
            {
                var b = JSON.parse(a).map(x=>`"${x}"`).join(",")
                return JSON.parse("[ "+ b + "]");
            },
            onChildChangeMultiP(value,slug)
            {

                this.fieldData[slug] = JSON.stringify(value);
            },
            onchildMultiChange(value,slug)
            {
this.fieldData[slug] = value;
this.fetching = false;
            },
            onChildChange(value,slug) {
                this.fieldData[slug] = JSON.stringify(value);
                this.showoptions = [];
this.fetching = false;
            },
            onMapChange(value,slug) {
                this.fieldData[slug] = value.position;

this.lat = value.position.lat;
this.lng = value.position.lng;

            this.fieldData["coords"][0][0] = this.lat + ", " + this.lng;
            this.fieldData["gpspoint"] = {"lat": this.lat,"lng": this.lng};

                if(!this.hasOwntitle || !this.fieldData["title"] && value.address)
                this.fieldData["title"] = value.address;


                this.componentKey += 1;
            },

formatDateX: function (dt) {
                return moment(dt).format('D.M.YYYY H:mm')

            },
            formatDateP(dt) {

                if(moment(dt, moment.ISO_8601, true).isValid())
                    return  moment(dt._d).format('lll');
                else
                    return moment.unix(dt).format('lll');


            },
            resolveAddress(slug)
            {
            if(this.fieldData[slug])
            return this.fieldData[slug];
            else
            {
               if(this.fieldData["coords"])
               { if(this.fieldData["coords"][0][0])
            {
                let ll = this.fieldData["coords"][0][0].split(", ");
                return {"lat": parseFloat(ll[0]), "lng": parseFloat(ll[1])};
            }
            }}
            },
            onChildTaxChange (value,slug)
            {   this.fieldData[slug] = value;

            },
            openImageModal(fieldSlug)
            {
          this.showImportModalImages = true;
          if(fieldSlug)
          this.fieldSlug = fieldSlug;
            },

            change({coordinates, canvas}) {
                this.croppedImage = canvas.toDataURL();
                this.imgCroppFile = canvas.toDataURL("image/jpeg");

            },
            handleChange(info) {

            },
            beforeUpload(file) {
                this.originInfo = file;
                const isJPG = file.type === 'image/jpeg';
                if (!isJPG) {
                    this.$message.error('You can only upload JPG file!');
                }
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isLt2M) {
                    this.$message.error('Image must smaller than 2MB!');

                }
                getBase64(file, imageUrl => {
                    this.imageUrl = imageUrl;
                    this.showModal();
      });
                return false;
            },
            sayshit(e) {
                console.log(e);
            },
            handleSubmit() {
                let $user_data = this.fieldData;
                dataService.axiosPost(this.$options.name, $user_data);
            },
            normFile(e) {
                if (Array.isArray(e)) {
                    return e;
                }
                return e && e.fileList;


            },
        },
        mounted() {


            dataService.axiosFetch("roles").then(results => { this.roles = results;
               var roleops = [];
               results.forEach(obj => { roleops.push({"value" : parseInt(obj.id) , "label" : obj.title}); });
               this.roleOptions = roleops;

                  dataService.axiosFetch('extrauserfields').then(results => {
                     results.fields.forEach(obj => { this.fields.push(obj); });

                     this.options = results.options;
                     this.optionsNew = results.optionsNew;
   this.options[123] = this.roleOptions;

                    });


                  if (!isNaN(this.id)) {
                dataService.axiosFetch(this.$options.name, this.id).then(results => {
                    this.fieldData = results;
                    if(this.fieldData.personal == "0")
                    this.fieldData.personal = false;
                    else
                    this.fieldData.personal = true;
                    this.loading = false;
                });
            }
            else
                    this.loading = false;
             });
        }




    };
</script>
<style>

    .input-group .input-group-prepend .input-group-text {
        border: 0;
    }
    .ant-upload.ant-upload-select-picture-card
    {
        background-color: transparent;
    border:0;}
    .avatar-uploader
    {z-index: 9999;
        position: relative;
        display: block;
        border-radius: 100%;
        overflow: hidden;
        top: -12px;}
    .ant-upload.ant-upload-select-picture-card > .ant-upload
    {color:#fff;}
  .edit-card >>> .ant-card-body
     {padding:0;}
</style>
